import React from "react"
import { FormattedMessage } from "react-intl"
import Tabs from "../common/layout/tabs.component"

type OwnProps = {
    hasActiveAccount: boolean
}

const PaymentProcessingTabs = (props: OwnProps) => {
    const paymentProcessingTabs = [
        {
            name: <FormattedMessage
                id="menu.tabs.payment_processing.payments"
                defaultMessage="Payments"
            />,
            link: "/payment-processing/payments",
            hidden: !props.hasActiveAccount,
        },
        {
            name: <FormattedMessage
                id="menu.tabs.payment_processing.payouts"
                defaultMessage="Payouts"
            />,
            link: "/payment-processing/payouts",
            hidden: !props.hasActiveAccount,
        },
        {
            name: <FormattedMessage
                id="menu.tabs.payment_processing.terminals"
                defaultMessage="Terminals"
            />,
            link: "/payment-processing/terminals",
            hidden: !props.hasActiveAccount,
        },
        {
            name: <FormattedMessage
                id="menu.tabs.payment_processing.3d_secure"
                defaultMessage="3D Secure"
            />,
            link: "/payment-processing/configuration-3ds",
            hidden: !props.hasActiveAccount,
        },
        {
            name: <FormattedMessage
                id="menu.tabs.payment_processing.accounts"
                defaultMessage="Accounts"
            />,
            link: "/payment-processing/accounts",
        },
    ]

    return (
        <Tabs value={paymentProcessingTabs} />
    )
}

export default PaymentProcessingTabs









// WEBPACK FOOTER //
// ./src/payment-processing/PaymentProcessingTabs.tsx